import React, { useEffect, useState } from "react";
import { isNull } from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";
import Dropdown from "rc-dropdown";
import Menu, { Item as MenuItem } from "rc-menu";
import Icon from "@client.components/Icon";
import ValidationError from "@client.components/ValidationError";
import "./Dropdown.scss";
import "rc-dropdown/assets/index.css";

const DropDownComponent = ({
  id,
  error = null,
  items,
  valueKey,
  labelKey,
  descriptionKey,
  defaultValue,
  onSelect,
  onPrepareValue,
  renderCustomContent,
  placeholder,
  disabled = false,
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  useEffect(() => {
    setSelectedValue(defaultValue);
  }, [defaultValue]);

  const renderOverlay = () => (
    <Menu
      selectedKeys={[selectedValue]}
      onSelect={({ key }) => {
        const value = onPrepareValue ? onPrepareValue(key) : key;
        setSelectedValue(value);
        if (onSelect) {
          onSelect(
            value,
            items.find((i) => i[valueKey] === value)
          );
        }
      }}
      className="dropdown-menu"
    >
      {items.map((item) => (
        <MenuItem
          key={item[valueKey]}
          className={classNames({ "with-description": !!descriptionKey })}
          onClick={item.onClick}
        >
          {item[labelKey]}
          {descriptionKey && item[descriptionKey] && (
            <span className="description">{item[descriptionKey]}</span>
          )}
        </MenuItem>
      ))}
    </Menu>
  );

  const selectedItem =
    items && items.find((i) => i[valueKey] === selectedValue);

  return (
    <div className="dropdown-container">
      <Dropdown
        trigger={["click"]}
        overlay={renderOverlay}
        animation="slide-up"
      >
        {renderCustomContent ? (
          renderCustomContent(selectedItem, id)
        ) : (
          <button
            disabled={disabled}
            id={id}
            className={classNames("dropdown", { "is-invalid": !isNull(error) })}
          >
            {selectedItem === undefined ? (
              <span className="placeholder">{placeholder}</span>
            ) : (
              selectedItem[labelKey]
            )}
            <Icon name="chevron" />
          </button>
        )}
      </Dropdown>
      <ValidationError error={error} />
    </div>
  );
};

DropDownComponent.propTypes = {
  id: PropTypes.string,
  error: PropTypes.array,
  items: PropTypes.array.isRequired,
  valueKey: PropTypes.string.isRequired,
  labelKey: PropTypes.string.isRequired,
  descriptionKey: PropTypes.string,
  defaultValue: PropTypes.any,
  placeholder: PropTypes.string,
  onSelect: PropTypes.func,
  onPrepareValue: PropTypes.func,
  renderCustomContent: PropTypes.func,
  disabled: PropTypes.bool,
};

export default DropDownComponent;
